// Theme/font keys are duplicated in index.html's inline boot script; change both together.

export interface Choice {
  id: string;
  name: string;
}

export const THEMES: Choice[] = [
  { id: 'monokai', name: 'Monokai Pro' },
  { id: 'vscode', name: 'VS Code Dark+' },
  { id: 'tokyo', name: 'Tokyo Night' },
  { id: 'indigo', name: 'Indigo Slate' },
  { id: 'latte', name: 'Catppuccin Latte — light' },
];

/** What a freshly added ladder opens into. */
export const PANEL_MODES: Choice[] = [
  { id: 'explore', name: 'Explore — search events first' },
  { id: 'ladder', name: 'Ladder — empty book' },
];

export const FONTS: Choice[] = [
  { id: 'inter', name: 'Inter / JetBrains Mono' },
  { id: 'courier', name: 'Courier New' },
];

const THEME_KEY = 'kg_theme';
const FONT_KEY = 'kg_font';
const MODE_KEY = 'kg_panel_mode';

const valid = (list: Choice[], id: string | null) =>
  (list.some((c) => c.id === id) ? (id as string) : list[0].id);

export function getTheme(): string {
  return valid(THEMES, localStorage.getItem(THEME_KEY));
}

export function getFont(): string {
  return valid(FONTS, localStorage.getItem(FONT_KEY));
}

export function setTheme(id: string): void {
  const v = valid(THEMES, id);
  localStorage.setItem(THEME_KEY, v);
  document.documentElement.dataset.theme = v;
}

export function setFont(id: string): void {
  const v = valid(FONTS, id);
  localStorage.setItem(FONT_KEY, v);
  document.documentElement.dataset.font = v;
}

export function getDefaultPanelMode(): string {
  return valid(PANEL_MODES, localStorage.getItem(MODE_KEY));
}

export function setDefaultPanelMode(id: string): void {
  localStorage.setItem(MODE_KEY, valid(PANEL_MODES, id));
}

/** Re-assert both, for the case where the inline boot script did not run. */
export function applySaved(): void {
  document.documentElement.dataset.theme = getTheme();
  document.documentElement.dataset.font = getFont();
}
